import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M14.747 9.712v1.72a3.325 3.325 0 0 1-3.32 3.32h-6.86a3.325 3.325 0 0 1-3.32-3.32v-6.86a3.325 3.325 0 0 1 3.32-3.32h1.72a.75.75 0 1 1 0 1.5h-1.72a1.82 1.82 0 0 0-1.82 1.82v6.86a1.827 1.827 0 0 0 1.82 1.82h6.86a1.82 1.82 0 0 0 1.82-1.82v-1.72a.75.75 0 0 1 1.5 0Zm-.73-8.45H9a.75.75 0 0 0 0 1.5h3.21l-5.72 5.72a.754.754 0 0 0 0 1.06.748.748 0 0 0 1.06 0l5.72-5.72v3.22a.75.75 0 0 0 1.5 0v-5.03a.749.749 0 0 0-.753-.75Z';
const draw24px = 'M19.75,5v5a.75.75,0,1,1-1.5,0V6.81l-6.72,6.72a.74.74,0,0,1-.53.22.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l6.72-6.72H14a.75.75,0,1,1,0-1.5h5a.72.72,0,0,1,.29.06.74.74,0,0,1,.4.4A.72.72,0,0,1,19.75,5Zm0,11V14a.75.75,0,0,0-1.5,0v2A2.25,2.25,0,0,1,16,18.25H8A2.25,2.25,0,0,1,5.75,16V8A2.25,2.25,0,0,1,8,5.75h2a.75.75,0,0,0,0-1.5H8A3.75,3.75,0,0,0,4.25,8v8A3.75,3.75,0,0,0,8,19.75h8A3.75,3.75,0,0,0,19.75,16Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const OpenIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'open'));
OpenIcon.displayName = 'OpenIcon';
OpenIcon.propTypes = Icon.propTypes;
OpenIcon.renderIcon = props => /*#__PURE__*/React.createElement(OpenIcon, props);
export default OpenIcon;
//# sourceMappingURL=OpenIcon.js.map